import React, { useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import PrintIcon from "@mui/icons-material/Print";
import CloseIcon from "@mui/icons-material/Close";
import { useReactToPrint } from "react-to-print";
import { FilledButton } from "../../customComponents/styled/styledButtons";
import { useGetSchoolProfileQuery } from "../settings/school/schoolApiSlice";
import UserAvatar from "../../common/UserAvatar";

const StudentIdCard = ({ open, onClose, student }) => {
  const cardRef = useRef();
  const { data: school } = useGetSchoolProfileQuery();

  const handlePrint = useReactToPrint({
    content: () => cardRef.current,
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        Student ID Card
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {/* ── Printable card area ─────────────────────────────── */}
        <Box
          ref={cardRef}
          sx={{
            border: "1.5px solid",
            borderColor: "divider",
            borderRadius: 2,
            p: 3,
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 0.5,
          }}
        >
          {/* School logo */}
          {school?.logo && (
            <Box
              component="img"
              src={school.logo}
              alt="school logo"
              sx={{ height: 64, width: 64, objectFit: "contain", mb: 0.5 }}
            />
          )}

          {/* School name */}
          {school?.name && (
            <Typography variant="subtitle1" fontWeight="bold">
              {school.name}
            </Typography>
          )}

          {/* School alias */}
          {school?.alias && (
            <Typography variant="body2" fontWeight="medium" color="text.secondary">
              {school.alias}
            </Typography>
          )}

          {/* School address */}
          {school?.address && (
            <Typography variant="caption" color="text.secondary">
              {school.address}
            </Typography>
          )}

          <Divider flexItem sx={{ my: 1.5 }} />

          {/* Student photo */}
          <UserAvatar
            src={student?.photo}
            name={`${student?.first_name || ""} ${student?.last_name || ""}`}
            sx={{ width: 96, height: 96, fontSize: "2.5rem", mb: 1 }}
          />

          {/* Student name */}
          <Typography variant="h6" fontWeight="bold">
            {student?.first_name} {student?.last_name}
          </Typography>

          {/* Reg number */}
          {student?.reg_number && (
            <Typography variant="body2" color="text.secondary">
              {student.reg_number}
            </Typography>
          )}
        </Box>

        {/* Print button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <FilledButton onClick={handlePrint} startIcon={<PrintIcon />}>
            Print
          </FilledButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default StudentIdCard;
